module.exports = __webpack_public_path__ + "static/media/fmlogo.0ae9de20.jpg";